export default __webpack_public_path__ + "static/char-s-48-zh-Hant-d063c2508dda8eb787340a9eedfb7d2a.png";